import { createAction } from 'redux-starter-kit';

export const SET_ASSETS = 'assets/SET_ASSETS';

export default {
  setAssets: createAction(SET_ASSETS),
};
